import React from 'react';
import I18n from 'i18n-js';
import Modal from '@reverbdotcom/commons/src/components/modal';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { Paths } from './shared/url_helpers';
import { RCButton, RCText } from '@reverbdotcom/cadence/components';


interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function UserPrivacyConsentPopup({ isOpen, onClose, onSubmit }: IProps) {
  return (
    <>
      <Modal
        isOpen={isOpen}
        position="bottom"
        size="wide"
        hideOverlay
        allowBackgroundScroll
        paddedBody
      >
        <RCText.Title
          size="500"
          htmlTag="h2"
        >
          {I18n.t('discovery.userPrivacyConsentModal.title')}
        </RCText.Title>
        <p className="mtb-4">
          <SanitizedRender
            html={I18n.t(
              'discovery.userPrivacyConsentModal.consentBlurb',
              {
                cookiePolicyLinkOpen: `<a href="${Paths.cookiePolicy.expand({})}" class="text-link weight-bold">`,
                linkClose: '</a>',
              },
            )}
          />
        </p>
        <div className="d-flex fx-justify-end fx-wrap gap-2">
          <RCButton
            variant="transparent"
            onClick={onClose}
          >
            {I18n.t('discovery.userPrivacyConsentModal.updateSettings')}
          </RCButton>
          <RCButton
            variant="filled"
            onClick={onSubmit}
          >
            {I18n.t('discovery.userPrivacyConsentModal.accept')}
          </RCButton>
        </div>
      </Modal>
    </>
  );
}
